/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Language_FrInputs */

const en_language_fr = /** @type {(inputs: Language_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Français`)
};

const fr_language_fr = /** @type {(inputs: Language_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Français`)
};

const ms_sg2_language_fr = /** @type {(inputs: Language_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Français`)
};

/**
* | output |
* | --- |
* | "Français" |
*
* @param {Language_FrInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const language_fr = /** @type {((inputs?: Language_FrInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Language_FrInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_language_fr(inputs)
	if (locale === "fr") return fr_language_fr(inputs)
	return ms_sg2_language_fr(inputs)
});